// @flow

export const SM = 768;
export const MD = 992;
export const LG = 1200;
export const XL = 1280;

export default {
  smAndAbove: { minWidth: `${SM}px` },
  mdAndAbove: { minWidth: `${MD}px` },
  lgAndAbove: { minWidth: `${LG}px` },
  xlAndAbove: { minWidth: `${XL}px` },
};
